import React from 'react';
import { observer } from 'mobx-react';
import { useAuthStore } from '../../../../auth/shared/store/useAuthStore';
import { PaymentMainGuest } from './PaymentMainGuest';
import { PaymentMainUser } from './PaymentMainUser';

export const PaymentMain = observer(() => {
	const authStore = useAuthStore();

	return authStore.isAuthenticated ? <PaymentMainUser /> : <PaymentMainGuest />;
});
